<template>
    <!-- <div class="empty-main">
        <div class="empty-inner">
            <img :src="`${$global.base_url}images/cannot-access.png`" alt="" />
            <h2> 404 Oops! Page not found </h2>
            <p> Sorry, but the page you are looking for is not found.</p>
            <a href="/"><button class="btn btn-primary mt-2">Go Home</button></a>
        </div> 
    </div>-->
</template>


<script>
export default {
    
    beforeCreate() {
        window.location.replace('/');
    },
}
</script>
